export default __webpack_public_path__ + "static/media/ic_school.e53f09e8.svg";